import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FezaDataService } from '../../services/fezadata.service';
import { FileService } from '../../services/file.service';
import { onerror } from 'q';
import { environment } from '../../../environments/environment';
import { BidMode, BidModeList } from '../../enums/bid-mode.enum';
import { ICountry } from '../../models/ICountry';
import { S1DataService } from '../../services/s1data.service';
import { LoadingProgress } from '../../models/ILoadingProgress';
import { IPerformanceSettingsModel } from '../../models/IPerformanceSettingsModel';
import { IPanelType } from '../../models/IPanelType';
import { PanelCheckTargetingModeList } from '../../enums/panel-check-targeting-mode.enum';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { IVirtualPanelImportLog } from '../../models/IVirtualPanelImportLog';
import { ITrackerDevianceModel } from '../../models/ITrackerDevianceModel';
import { ICheckedItem } from '../../models/ICheckedItem';
import { IPanelCountryLanguage } from '../../models/IPanelCountryLanguage';
import { map } from 'rxjs/operators';
import { error } from 'protractor';

@Component({
  selector: 'app-settings-page',
  templateUrl: './settings-page.component.html',
  styleUrls: ['./settings-page.component.css']
})

export class SettingsPageComponent implements OnInit {
  form: FormGroup;
  virtDataProgress: LoadingProgress = new LoadingProgress();
  fileConfigBasePath: string;
  supplierUrl: string;
  fezeUrl: string;
  supportEmail: string;
  bidModeWaitTimes: Map<string, number>;
  bidModeList: string[];
  waitForWaitTimes: boolean;
  countryCode: string;
  panelCountryCode: string;
  countryList$: Observable<Array<ICountry>>;
  panelCountryList$: Observable<IPanelCountryLanguage[]>;
  virtualPanels$: Observable<string[]>;
  panelList$: Observable<IPanelType[]>;
  virtualPanelImportLogList$: Observable<IVirtualPanelImportLog[]>;
  virtualPanel: string;
  supplierId: string;
  supplierGroupId: string
  performanceSettings: IPerformanceSettingsModel;
  fezaCacheSetting: number;
  apiTimeoutSetting: number;
  epcValue: number;
  fullyPopThreshold: number;
  panelCheckTargetingModeList = PanelCheckTargetingModeList;
  panelCheckTargetingMode: string;
  showLastFailedImportsNumber: number;
  trackerDeviations: ITrackerDevianceModel;
  panelOneImportEnabledFlag: boolean;
  recruitmentVariables: Array<ICheckedItem>;
  ageBreaks: Array<{ item1: number; item2: number }>;
  recruitmentReportChangesError: string;
  ageBreakError: string;
  feApiFallBackCallsEnabled: boolean;

  constructor(private fb: FormBuilder,
    private fezaService: FezaDataService,
    private fileService: FileService,
    private dataService: S1DataService) {
    this.performanceSettings = {} as IPerformanceSettingsModel;
    this.bidModeWaitTimes = new Map<string, number>();
    this.fileConfigBasePath = environment.fileConfigBasePath;
    this.supplierUrl = environment.supplierUrl;
    this.fezeUrl = environment.fezeUrl;
    this.showLastFailedImportsNumber = 0;
    this.trackerDeviations = {} as ITrackerDevianceModel;

    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({ onVirtPanelFile: null });
  }

  ngOnInit() {
    this.virtualPanels$ = this.fezaService.GetVirtalPanels();
    this.fezaService.GetSupportEmail().subscribe(x => this.supportEmail = x);
    this.countryList$ = this.dataService.getCountries();
    this.panelCountryList$ = this.fezaService.getPanelCountries();
    this.virtualPanels$ = this.fezaService.GetVirtalPanels();
    this.panelList$ = this.fezaService.getPanels();
    this.virtualPanelImportLogList$ = this.fezaService.getVirtualPanelImportLogs();
    this.getBidModeWaitTimes();
    this.fezaService.GetPerfromanceSettings().subscribe(settings => this.performanceSettings = settings);
    this.fezaService.GetFezaCacheSetting().subscribe(x => this.fezaCacheSetting = x);
    this.fezaService.GetFezaApiTimeoutSetting().subscribe(x => this.apiTimeoutSetting = x);
    this.fezaService.GetEpcValue().subscribe(x => this.epcValue = x);
    this.fezaService.GetFullyPopThreshold().subscribe(x => this.fullyPopThreshold = x);
    this.fezaService.GetPanelCheckTargetingMode().subscribe(x => this.panelCheckTargetingMode = x);
    this.fezaService.GetTrackerDeviations().subscribe(trackerDeviations => this.trackerDeviations = trackerDeviations);
    this.fezaService.GetPanelOneImportEnabledFlag().subscribe(result=> this.panelOneImportEnabledFlag = result);
    this.fezaService.GetFeApiFallBackCallsFlag().subscribe(r=>this.feApiFallBackCallsEnabled = r);
  }

  getBidModeWaitTimes() {
    this.bidModeList = [];
    this.waitForWaitTimes = true;
    var waitTimeGetters = [];
    BidModeList.forEach((mode, index) => {
      if (mode.name !== null) {
        this.bidModeList.push(mode.name);
        this.bidModeWaitTimes[mode.name] = "";
        waitTimeGetters.push(this.fezaService.GetBidModeWaitTime(mode.name));
      }
    });
    Observable.forkJoin(waitTimeGetters).subscribe(data => {
      this.bidModeList.forEach((mode, index) => { this.bidModeWaitTimes[mode] = data[index]; });
      this.waitForWaitTimes = false;
    }, err => {
      this.waitForWaitTimes = false;
      console.log(`bidMode getter error! err:${err}`);
    });
  }

  onUpdateBidModeWaitTimes() {
    var setters = [];
    this.bidModeList.forEach((mode, index) => { setters.push(this.fezaService.SetBidModeWaitTime(mode, this.bidModeWaitTimes[mode])); });
    Observable.forkJoin(setters).subscribe(data => { this.getBidModeWaitTimes(); });
  }

  private prepareSave(fileName): FormData {
    if (!this.form.get(fileName).value)
      return null;
    let input = new FormData();
    input.append('file', this.form.get(fileName).value);
    return input;
  }

  onUpdateEmailAddress() {
    this.fezaService.SetSupportEmail(this.supportEmail).subscribe(x => { });
  }

  onRecruitmentCountryChange() {
    if (this.panelCountryCode) {
      this.recruitmentVariables = [];
      this.fezaService.GetPanelVariables(this.panelCountryCode).pipe(map(x => x.map(x => new ICheckedItem(x.p1Variable1Name, x.selected)))).subscribe(x => {
        this.recruitmentVariables = x;
      });

      this.fezaService.GetAgeBreaks(this.panelCountryCode).subscribe(x=> {
        this.ageBreaks = x;
        if (this.ageBreaks.length == 0)
           this.ageBreaks = [{item1: 18, item2: 24}, {item1: 25, item2:34}, {item1: 35, item2: 44}, {item1: 45, item2: 54}, {item1:55, item2: 64}, {item1: 65, item2: 100}];        
        this.ageBreaks.push({item1: 0, item2:0});
        this.ageBreaks.push({item1: 0, item2:0});
        this.ageBreaks.push({item1: 0, item2:0});
      });
    }
  }

  onSaveAgeBreaks(){
    this.ageBreaks = this.ageBreaks.filter(x=>x.item1 != 0);
    this.fezaService.SaveAgeBreaks(this.panelCountryCode, this.ageBreaks).subscribe(x => this.ageBreakError = "", error => this.ageBreakError = "error saving");
  }

  onSaveRecruitmentReportChanges() {
    this.recruitmentReportChangesError = "";
    var lst = [];
    for (var item of this.recruitmentVariables) {
      if (item.selected) {
        lst.push(item.name);
      }
    }
    this.fezaService.SaveRecruitmentReportChanges(this.panelCountryCode, lst).subscribe(x => this.recruitmentReportChangesError = "", error => this.recruitmentReportChangesError = "error saving");
  }

  onGetFileBeatLogFile(beatLogName) {
    this.fileService.downloadSecureFile(this.fileConfigBasePath + `BeatLogExport/${beatLogName}`, `${beatLogName}.xlsx`);
  }

  onGetPanelData(panelName: string, countryCode: string) {
    this.fileService.downloadSecureFile(this.fileConfigBasePath + `PanelDataExport/${panelName}?countryCode=${this.countryCode || ""}`, `${panelName}.xlsx`);
  }

  onGetStandardQuestionsFile() {
    var country = this.countryCode === "-" ? "" : (this.countryCode || "");
    this.fileService.downloadSecureFile(this.fileConfigBasePath + `StandardQuestions?CountryCode=${country}`, "StandardQuestions.xlsx");
  }

  onVirtFileChange(event) {
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      this.form.get('onVirtPanelFile').setValue(file);
    }
  }

  onVirtUpload() {
    var supplierGroupPart = '';
    if (this.supplierGroupId) supplierGroupPart = `?supplierGroupId=${this.supplierGroupId}`;
    this.fezaService.UploadFile(this.supplierUrl + `/api/v1/panel/VirtualPanel/${this.countryCode}/${this.supplierId}${supplierGroupPart}`, this.prepareSave("onVirtPanelFile")).subscribe(res => {
      this.virtDataProgress.setRes(res);
      this.fezaService.DropCache(this.fezeUrl + `/api/v1/Cache/DropCache?areas=PanelMetadata`).subscribe(resDropCache => { this.virtualPanels$ = this.fezaService.GetVirtalPanels();})      
    },
      err => {
        this.virtDataProgress.setRes("Error:" + onerror);
      });
  }

  onVirtDownload() {
    var vpNameArray = this.virtualPanel.split('_');
    
    var [typeOfVp,id,country,parentGroupId] = vpNameArray;

    if (typeOfVp.toUpperCase() === "VIRTUALPANELGROUP")
      this.fileService.downloadSecureFile(this.supplierUrl + `/api/v1/panel/VirtualPanelGroup/${country}/${id}`, `VirtualPanelGroup_${id}_${country}.xlsx`);
    else if (parentGroupId) 
        this.fileService.downloadSecureFile(this.supplierUrl + `/api/v1/panel/VirtualPanel/${country}/${id}?supplierGroupId=${parentGroupId}`, `VirtualPanel_${id}_${country}_${parentGroupId}.xlsx`);    
    else 
        this.fileService.downloadSecureFile(this.supplierUrl + `/api/v1/panel/VirtualPanel/${country}/${id}`, `VirtualPanel_${id}_${country}.xlsx`);      
  }


  onDropVirtualPanel() {
    if (confirm("Are you sure you want to drop data for " + this.virtualPanel)) {

      var vpNameArray = this.virtualPanel.split('_');
    
      var [typeOfVp,id,country,parentGroupId] = vpNameArray;

        this.fezaService.DropVirtualPanelTable(typeOfVp, id, country, parentGroupId)
          .subscribe(x => this.fezaService.DropCache(this.fezeUrl + `/api/v1/Cache/DropCache?areas=PanelMetadata`).subscribe(resDropCache => { this.virtualPanels$ = this.fezaService.GetVirtalPanels(); }));
    }
  }

  onUpdatePerformance() {
    this.fezaService.SetPerfromanceSettings(this.performanceSettings).subscribe(x => {
      this.fezaService.GetPerfromanceSettings().subscribe(settings => this.performanceSettings = settings);
    });
  }

  onUpdateTrackerDeviations() {
    this.fezaService.SetTrackerDeviations(this.trackerDeviations).subscribe(x => {
      this.fezaService.GetTrackerDeviations().subscribe(settings => this.trackerDeviations = settings);
    });
  }
  
  onUpdateFezaCacheDays() {
    this.fezaService.SetFezaCacheSetting(this.fezaCacheSetting).subscribe(done => {
      this.fezaService.GetFezaCacheSetting().subscribe(x => this.fezaCacheSetting = x);
    }, err => {
      this.fezaService.GetFezaCacheSetting().subscribe(x => this.fezaCacheSetting = x);
    });
  }

  onUpdateApiTimeoutSetting() {
    this.fezaService.SetFezaApiTimeoutSetting(this.apiTimeoutSetting).subscribe(done => {
      this.fezaService.GetFezaApiTimeoutSetting().subscribe(x => this.apiTimeoutSetting = x);
    }, err => {
        this.fezaService.GetFezaApiTimeoutSetting().subscribe(x => this.apiTimeoutSetting = x);
    });
  }


  onUpdateEpcValue() {
    this.fezaService.SetEpcValue(this.epcValue).subscribe(done => {
      this.fezaService.GetEpcValue().subscribe(x => this.epcValue = x);
    },
      err => {
        this.fezaService.GetEpcValue().subscribe(x => this.epcValue = x);
      })
  }

  onUpdateFullyPopThresholdValue() {
    this.fezaService.SetFullyPopThreshold(this.fullyPopThreshold).subscribe(done => {
      this.fezaService.GetFullyPopThreshold().subscribe(x => this.fullyPopThreshold = x),
        err => {
          this.fezaService.GetFullyPopThreshold().subscribe(x => this.fullyPopThreshold = x)
      }
    })
  }

  onGetNatRepUploadSummary() {
    this.fileService.downloadSecureFile(this.fileConfigBasePath + `GetNatRepUploadSummary`, "NatRepSummary.xlsx");
  }

  onPanelCheckTargetingMode() {
    this.fezaService.SetPanelCheckTargetingMode(this.panelCheckTargetingMode).subscribe(done => {
      this.fezaService.GetPanelCheckTargetingMode().subscribe(x => this.panelCheckTargetingMode = x),
        err => {
          this.fezaService.GetPanelCheckTargetingMode().subscribe(x => this.panelCheckTargetingMode = x)
        }
    })
  }

  onRefreshVpLogData() {
    this.virtualPanelImportLogList$ = this.fezaService.getVirtualPanelImportLogs();
  }

  onDownloadVpLogFile(virtualPanelImportLogId: number, fileName: string) {
    this.fileService.downloadSecureFile(this.supplierUrl + `/api/v1/panel/virtualpaneldownloadfile/${virtualPanelImportLogId}`, fileName);
  }

  onDropVpLogFile(virtualPanelImportLogId: number) {
    this.fezaService.dropVirtualPanelLogFile(virtualPanelImportLogId)
      .subscribe(x => this.virtualPanelImportLogList$ = this.fezaService.getVirtualPanelImportLogs());
  }

  onGetVirtualPanelImportSummary(showLastFailedImportsNumber: number) {
    this.fileService.downloadSecureFile(this.supplierUrl + `/api/v1/panel/virtualpanel/import-summary?showLastFailedImportsNumber=` + showLastFailedImportsNumber, "VirtualPanelImportSummary.xlsx");
  }

  onUpdatePanelOneImportEnabledFlag(){
    this.fezaService.SetPanelOneImportEnabledFlag(this.panelOneImportEnabledFlag)
    .subscribe(resp=> 
        this.fezaService.GetPanelOneImportEnabledFlag()
            .subscribe(res => 
                this.panelOneImportEnabledFlag = res));
  }

  onUpdateFeApiFallBackCallsFlag(){
    this.fezaService.SetFeApiFallBackCallsFlag(this.feApiFallBackCallsEnabled)
    .subscribe(resp=> 
        this.fezaService.GetFeApiFallBackCallsFlag()
            .subscribe(res => 
                this.feApiFallBackCallsEnabled = res));
  }
}




// WEBPACK FOOTER //
// ./src/app/components/settings-page/settings-page.component.ts